import { cn } from '@tempo-io/sui-class-utils';
import type { ReactNode } from 'react';
import type { ActualCostCompletenessStatus } from '@/common/api/types/itemFinancials';
import { ActualCostStatusIndicator } from './ActualCostStatusIndicator';

export const ActualCostAmount = ({
  amount,
  status,
  className,
  itemId,
  selfStatus,
}: {
  amount: ReactNode;
  status: ActualCostCompletenessStatus | null | undefined;
  className?: string;
  itemId?: number;
  selfStatus?: ActualCostCompletenessStatus | null;
}) => (
  <span className={cn('inline-flex items-center gap-1.5', className)}>
    <ActualCostStatusIndicator status={status} itemId={itemId} selfStatus={selfStatus} />
    {amount}
  </span>
);
